import { LinearProgress } from '@mui/material';
//import { useTheme } from '@mui/material';

const Loading=()=>{
    //const theme = useTheme();
    return (
        <LinearProgress>
        {/*<Box sx={{
            position:'absolute',
            top:'50%',
            left:'50%',
            transform:'translate(-50%,-50%)',
            width:'150px',
            height:'150px',
            background:'transparent',
            border:'3px solid #cccccc',
            borderRadius:'50%',
            textAlign:'center',
            lineHeight:'150px',
            fontSize:20,
            color:`${theme.palette.primary.main}`,
            letterSpacing:4,
            textShadow:`0 0 10px ${theme.palette.primary.main}`,
            boxShadow:'0 0 20px rgba(0,0,0,.5)',
            '&::before':{
                content:'""',
                position:'absolute',
                top:'-3px',
                left:'-3px',
                width:'100%',
                height:'100%',
                border:'3px solid transparent',
                borderTop:`3px solid ${theme.palette.primary.main}`,
                borderRight:`3px solid ${theme.palette.primary.main}`,
                borderRadius:'50%',
                animation:'animateLoadingC 2s linear infinite'
            },
            '@keyframes animateLoadingC':{
                '0%':
                {
                  transform:'rotate(0deg)'
                },
                '100%':
                {
                  transform:'rotate(360deg)'
                }
              },
        }}>LOADING
            <Box sx={{
                display:'block',
                position:'absolute',
                top:`calc(50% - 2px)`,
                left:'50%',
                width:'50%',
                height:'4px',
                background:'transparent',
                transformOrigin:'left',
                animation:'animateLoading 2s linear infinite',
                '&::before':{
                    content:'""',
                    position:'absolute',
                    width:'16px',
                    height:'16px',
                    borderRadius:'50%',
                    background:`${theme.palette.primary.main}`,
                    top:'-6px',
                    right:'-8px',
                    boxShadow:`0 0 20px ${theme.palette.primary.main}`,
                },
                '@keyframes animateLoading':{
                    '0%':
                    {
                    transform:'rotate(45deg)'
                    },
                    '100%':
                    {
                    transform:'rotate(405deg)'
                    }
                }
            }}
            ></Box>
        </Box>*/}
        </LinearProgress>)
}

export default Loading;